import React, { useState, useEffect } from "react";

import { Formik, Form } from "formik";

import cdeDefinitionsExploreApi from "apis/cdeDefinitionsExplore";
import { Button, Pane, Typography } from "clearsense-ui/components";
import {
  Input,
  Select,
  Switch,
  Textarea,
} from "clearsense-ui/components/formik";

import {
  ATTRIBUTE_TYPES,
  getLabelByValue,
  INITIAL_VALUES,
  renderValueField,
  VALIDATION_SCHEMA,
} from "../../constants/addNewCDERule";

const AddRule = ({
  isPaneOpen,
  setIsPaneOpen,
  cde,
  fetchCdeRulesData,
  getCde,
  currentlyEditedId,
}) => {
  const [currentlyEditedCdeRule, setCurrentlyEditedCdeRule] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async values => {
    try {
      const formattedParams = values;
      formattedParams.name = formattedParams?.name?.value;
      switch (formattedParams.name) {
        case "min_data_length":
        case "max_data_length":
        case "data_length":
          formattedParams.value = formattedParams.value.toString();
          break;
        case "datatype":
          formattedParams.name = formattedParams.value;
          formattedParams.value = "true";
          break;
        case "null_not_possible":
          formattedParams.value = "true";
          break;
        default:
          break;
      }
      currentlyEditedId
        ? await cdeDefinitionsExploreApi.updateCdeRule(
            cde.id,
            currentlyEditedId,
            formattedParams
          )
        : await cdeDefinitionsExploreApi.createCdeRule(cde.id, formattedParams);
      await fetchCdeRulesData();
      await getCde();
      setIsPaneOpen(false);
    } catch (error) {
      logger.log(error);
    }
  };

  const getCurrentlyEditedRule = async () => {
    try {
      setIsLoading(true);
      const { data } = await cdeDefinitionsExploreApi.showCdeRule(
        cde.id,
        currentlyEditedId
      );
      setCurrentlyEditedCdeRule(data);
    } catch (error) {
      logger.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getAttributeSelectOption = name => {
    if (["alphanumeric", "numeric", "letters_only"].includes(name)) {
      return { label: "Data Type", value: "datatype" };
    }

    return { label: getLabelByValue(name), value: name };
  };

  useEffect(() => {
    currentlyEditedId && isPaneOpen && getCurrentlyEditedRule();
  }, [currentlyEditedId, isPaneOpen]);

  return (
    <Pane
      isOpen={isPaneOpen}
      size="md"
      loading={isLoading}
      onClose={() => setIsPaneOpen(false)}
    >
      <Pane.Header className="-mt-2">
        <Typography style="h3" type="semibold">
          {currentlyEditedId
            ? `Edit "${currentlyEditedCdeRule.title}" Rule`
            : "Add a new Rule"}
        </Typography>
        <Typography style="large">
          Set quality analysis rules for {cde?.name} CDE
        </Typography>
      </Pane.Header>
      <Formik
        initialValues={
          currentlyEditedId
            ? {
                ...currentlyEditedCdeRule,
                name: getAttributeSelectOption(currentlyEditedCdeRule.name),
              }
            : INITIAL_VALUES
        }
        enableReinitialize
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form noValidate>
            <Pane.Body>
              <div className="mt-8 flex flex-col gap-4 w-full">
                <Input
                  name="title"
                  label="Title"
                  placeholder="Enter the title of the rule"
                  required
                />
                <Textarea
                  name="description"
                  label="Description"
                  placeholder="Enter the description for the rule"
                />
                <Select
                  name="name"
                  label="Attribute"
                  placeholder="Select the attribute"
                  options={ATTRIBUTE_TYPES}
                  onChange={e => {
                    setFieldValue("name", e);
                    setFieldValue("value", "");
                  }}
                  required
                />
                {renderValueField(
                  values?.name?.value || currentlyEditedCdeRule.name
                )}
                <Switch name="active" label="Activate Rule" className="mt-4" />
              </div>
            </Pane.Body>
            <Pane.Footer className="gap-2">
              <Button
                label="Submit"
                type="submit"
                disabled={
                  !(
                    values?.name?.value === "null_not_possible" ||
                    values?.value?.trim()
                  )
                }
              />
              <Button
                label="Cancel"
                type="reset"
                style="secondary"
                onClick={() => setIsPaneOpen(false)}
              />
            </Pane.Footer>
          </Form>
        )}
      </Formik>
    </Pane>
  );
};

export default AddRule;
